/**
 * CTR Quarterly Funnel Buy Box
 * Plan toggle, per-bottle scent slots, picker, tier pricing, ATC, gallery override.
 */
function initCtrQuarterlyFunnelBuyBox() {
  const root = document.querySelector('[data-ctr-quarterly-buy-box]');
  if (!root) return;

  const slotsEl = root.querySelector('[data-ctr-qf-slots]');
  const slotsWrap = root.querySelector('.ctr-qf-buy-box__slots-wrap');
  const slotTemplate = document.querySelector('[data-ctr-qf-slot-template]');
  const pickerEl = root.querySelector('[data-ctr-qf-picker]');
  const pickerCloseBtn = root.querySelector('[data-ctr-qf-picker-close]');
  const addBottleBtn = root.querySelector('[data-ctr-qf-add-bottle]');
  const planCards = root.querySelectorAll('[data-ctr-qf-plan]');
  const atcBtn = root.querySelector('[data-ctr-qf-atc]');
  const ctaLabelEl = root.querySelector('[data-ctr-qf-cta-label]');
  const upsellEl = root.querySelector('[data-ctr-qf-upsell]');
  const trustDeliveryTextEl = root.querySelector('[data-ctr-qf-trust-delivery-text]');
  const summaryOffValueEl = root.querySelector('[data-ctr-qf-summary-off-value]');
  const summaryCompareEl = root.querySelector('[data-ctr-qf-summary-compare]');
  const summaryTotalEl = root.querySelector('[data-ctr-qf-summary-total]');
  const summaryPerEl = root.querySelector('[data-ctr-qf-summary-per]');
  const summaryTitleEl = root.querySelector('[data-ctr-qf-summary-title]');
  const summaryOffEl = root.querySelector('[data-ctr-qf-summary-off]');
  const bottleCountEl = root.querySelector('[data-ctr-qf-bottle-count]');
  const bottleCountOnlyEl = root.querySelector('[data-ctr-qf-bottle-count-only]');
  const bottleSuffixEl = root.querySelector('[data-ctr-qf-bottle-suffix]');
  const bottleSuffixOnlyEl = root.querySelector('[data-ctr-qf-bottle-suffix-only]');
  const summaryHeadingTotalEl = root.querySelector('[data-ctr-qf-summary-heading-total]');
  const summaryHeadingCountOnlyEl = root.querySelector('[data-ctr-qf-summary-heading-count-only]');
  const cartDrawer = document.querySelector('cart-drawer');

  const minBottles = Number.parseInt(root.getAttribute('data-min-bottles'), 10) || 3;
  const maxBottles = Number.parseInt(root.getAttribute('data-max-bottles'), 10) || 0;
  const enableGallery = root.getAttribute('data-enable-gallery-override') === 'true';
  const defaultScentVariantId = root.getAttribute('data-default-scent-variant-id') || '';
  let activeSlotIndex = null;
  let selectedPlan = root.getAttribute('data-selected-plan') || 'quarterly';
  let pickerCloseTimer = null;
  let pickerTransitionHandler = null;
  const PICKER_MOTION_MS = 320;

  const cfg = {
    priceDisplayMode: root.getAttribute('data-price-display-mode') || 'total',
    baseOnetime: Number.parseFloat(root.getAttribute('data-base-onetime-price')) || 39,
    tier1Pct: Number.parseInt(root.getAttribute('data-tier-1-percent'), 10) || 13,
    tier2Pct: Number.parseInt(root.getAttribute('data-tier-2-percent'), 10) || 18,
    tier3Pct: Number.parseInt(root.getAttribute('data-tier-3-percent'), 10) || 23,
    quarterlyPlanId: root.getAttribute('data-quarterly-plan-id') || '',
    bimesterPlanId: root.getAttribute('data-bimester-plan-id') || '',
    summaryHeading: root.getAttribute('data-summary-heading') || '',
    perBottleText: root.getAttribute('data-per-bottle-text') || '',
    planQuarterlyBilling: root.getAttribute('data-plan-quarterly-billing') || '',
    planBimesterBilling: root.getAttribute('data-plan-bimester-billing') || '',
    ctaDisabled: root.getAttribute('data-cta-disabled') || '',
    ctaPrefix: root.getAttribute('data-cta-prefix') || '',
    ctaLoading: root.getAttribute('data-cta-loading') || 'Adding...',
    ctaAdded: root.getAttribute('data-cta-added') || 'Added!',
    leadAtcDestination: root.getAttribute('data-lead-atc-destination') || 'cart',
    trustDeliveryText: root.getAttribute('data-trust-delivery-text') || '',
    planQuarterlyDelivery: root.getAttribute('data-plan-quarterly-delivery') || '',
    planBimesterDelivery: root.getAttribute('data-plan-bimester-delivery') || '',
    selectAtLeastOne: root.getAttribute('data-select-at-least-one') || 'Select At Least {count} Bottle',
    selectAtLeastOther: root.getAttribute('data-select-at-least-other') || 'Select At Least {count} Bottles',
    alertSelectScents: root.getAttribute('data-alert-select-scents') || 'Please select a scent for each bottle.',
    alertCartError: root.getAttribute('data-alert-cart-error') || 'There was an error adding items to the cart. Please try again.',
    removeScentAria: root.getAttribute('data-remove-scent-aria') || 'Remove scent',
    removeBottleAria: root.getAttribute('data-remove-bottle-aria') || 'Remove bottle',
    bottleLabelSingular: root.getAttribute('data-bottle-label-singular') || 'bottle',
    bottleLabelPlural: root.getAttribute('data-bottle-label-plural') || 'bottles'
  };

  const interpolate = (template, vars) => {
    if (!template) return '';
    return template.replace(/\{(\w+)\}/g, (_, key) => (vars[key] != null ? String(vars[key]) : ''));
  };

  const getPlanBillingPhrase = () =>
    selectedPlan === 'bimester' ? cfg.planBimesterBilling : cfg.planQuarterlyBilling;

  const getPlanDeliveryPhrase = () =>
    selectedPlan === 'bimester' ? cfg.planBimesterDelivery : cfg.planQuarterlyDelivery;

  const getSlots = () => [...slotsEl.querySelectorAll('[data-ctr-qf-slot]')];

  const formatPrice = (value) => {
    const n = Number.parseFloat(value) || 0;
    return n % 1 === 0 ? n.toString() : n.toFixed(2);
  };

  const getBottleCount = () => getSlots().length;

  const getTierPercent = (count) => {
    if (count <= 2) return cfg.tier1Pct;
    if (count === 3) return cfg.tier2Pct;
    return cfg.tier3Pct;
  };

  const getTierIndex = (count) => {
    if (count <= 1) return 1;
    if (count === 2) return 2;
    if (count === 3) return 3;
    return 4;
  };

  const getTierPrices = (count) => {
    const tier = getTierIndex(count);
    const dis = Number.parseFloat(root.getAttribute(`data-bundle${tier}-dis`));
    const org = Number.parseFloat(root.getAttribute(`data-bundle${tier}-org`));
    const com = Number.parseFloat(root.getAttribute(`data-bundle${tier}-com`));
    return {
      dis: Number.isNaN(dis) ? 0 : dis,
      org: Number.isNaN(org) ? cfg.baseOnetime : org,
      com: Number.isNaN(com) ? 0 : com
    };
  };

  const getFilledSlots = () => getSlots().filter((slot) => slot.getAttribute('data-filled') === 'true');

  const getFilledCount = () => getFilledSlots().length;

  const getSelectAtLeastText = (remaining) => {
    const template = remaining === 1 ? cfg.selectAtLeastOne : cfg.selectAtLeastOther;
    return interpolate(template, { count: remaining });
  };

  const getSelectedSellingPlanId = () =>
    selectedPlan === 'bimester' ? cfg.bimesterPlanId : cfg.quarterlyPlanId;

  const syncTotalQty = () => {
    root.setAttribute('total-qty', String(getFilledCount()));
  };

  const applyDefaultTierOneScent = () => {
    if (!defaultScentVariantId) return;
    const firstSlot = getSlots()[0];
    if (!firstSlot || firstSlot.getAttribute('data-filled') === 'true') return;

    const defaultOption = [...root.querySelectorAll('[data-ctr-qf-scent-option]')].find(
      (option) => !option.disabled && option.getAttribute('data-variant-id') === defaultScentVariantId
    );

    if (!defaultOption) return;
    fillSlot(firstSlot, defaultOption);
  };

  const reindexSlots = () => {
    getSlots().forEach((slot, index) => {
      slot.setAttribute('data-slot-index', String(index));
    });
  };

  const isExtraSlot = (slotEl) => slotEl.getAttribute('data-extra-slot') === 'true';

  const updateSlotRemoveButton = (slotEl) => {
    const removeBtn = slotEl.querySelector('[data-ctr-qf-slot-remove]');
    if (!removeBtn) return;
    const filled = slotEl.getAttribute('data-filled') === 'true';
    const extra = isExtraSlot(slotEl);
    removeBtn.hidden = !(filled || extra);
    removeBtn.setAttribute('aria-label', extra ? cfg.removeBottleAria : cfg.removeScentAria);
  };

  const syncAllSlotRemoveButtons = () => {
    getSlots().forEach(updateSlotRemoveButton);
  };

  const removeSlot = (slotEl) => {
    if (!isExtraSlot(slotEl)) return false;

    const removeIndex = Number.parseInt(slotEl.getAttribute('data-slot-index'), 10);
    if (isPickerOpen()) {
      if (!Number.isNaN(removeIndex) && activeSlotIndex === removeIndex) {
        closePicker();
      }
    }

    slotEl.remove();
    reindexSlots();

    if (enableGallery) {
      const remaining = getFilledSlots();
      galleryController.onScentSelected(remaining.length ? remaining[0] : null);
    }

    return true;
  };

  const setSlotPickerState = (slotEl, isOpen) => {
    if (!slotEl) return;
    const trigger = slotEl.querySelector('[data-ctr-qf-slot-trigger]');
    slotEl.classList.toggle('is-picker-active', isOpen);
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };

  const clearSlotPickerStates = () => {
    getSlots().forEach((slot) => setSlotPickerState(slot, false));
  };

  const positionPicker = (slot) => {
    if (!pickerEl || !slotsWrap || !slot) return;
    const wrapTop = slotsWrap.getBoundingClientRect().top;
    const slotBottom = slot.getBoundingClientRect().bottom;
    pickerEl.style.top = `${slotBottom - wrapTop - 1}px`;
  };

  const isPickerOpen = () => root.classList.contains('is-picker-open');

  const cancelPickerCloseAnimation = () => {
    if (pickerCloseTimer) {
      clearTimeout(pickerCloseTimer);
      pickerCloseTimer = null;
    }
    if (pickerEl && pickerTransitionHandler) {
      pickerEl.removeEventListener('transitionend', pickerTransitionHandler);
      pickerTransitionHandler = null;
    }
  };

  const finalizePickerClose = () => {
    cancelPickerCloseAnimation();
    if (pickerEl) {
      pickerEl.hidden = true;
      pickerEl.setAttribute('aria-hidden', 'true');
      pickerEl.style.top = '';
    }
    root.classList.remove('is-picker-open');
  };

  const openPicker = (slotIndex) => {
    const slots = getSlots();
    const slot = slots[slotIndex];
    if (!slot || !pickerEl) return;

    const wasOpen = isPickerOpen();
    cancelPickerCloseAnimation();

    clearSlotPickerStates();
    activeSlotIndex = slotIndex;
    setSlotPickerState(slot, true);
    positionPicker(slot);
    pickerEl.hidden = false;

    if (!wasOpen) {
      root.classList.remove('is-picker-open');
      pickerEl.setAttribute('aria-hidden', 'true');
      requestAnimationFrame(() => {
        root.classList.add('is-picker-open');
        pickerEl.setAttribute('aria-hidden', 'false');
      });
    } else {
      root.classList.add('is-picker-open');
      pickerEl.setAttribute('aria-hidden', 'false');
    }
  };

  const closePicker = () => {
    if (!pickerEl || (pickerEl.hidden && !isPickerOpen())) return;

    clearSlotPickerStates();
    activeSlotIndex = null;
    root.classList.remove('is-picker-open');
    pickerEl.setAttribute('aria-hidden', 'true');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      finalizePickerClose();
      return;
    }

    cancelPickerCloseAnimation();
    pickerTransitionHandler = (e) => {
      if (e.target !== pickerEl) return;
      if (e.propertyName !== 'opacity' && e.propertyName !== 'transform') return;
      finalizePickerClose();
    };
    pickerEl.addEventListener('transitionend', pickerTransitionHandler);
    pickerCloseTimer = setTimeout(finalizePickerClose, PICKER_MOTION_MS);
  };

  const fillSlot = (slotEl, optionBtn) => {
    const variantId = optionBtn.getAttribute('data-variant-id');
    const title = optionBtn.getAttribute('data-title') || '';
    const image = optionBtn.getAttribute('data-image') || '';
    const badge =
      optionBtn.getAttribute('data-slot-badge') ||
      optionBtn.getAttribute('data-badge') ||
      '';
    const badgeColor = optionBtn.getAttribute('data-slot-badge-color') || '';
    const bgColor = optionBtn.getAttribute('data-bg-color') || '';
    const gallery = optionBtn.getAttribute('data-gallery') || '[]';

    slotEl.setAttribute('data-filled', 'true');
    slotEl.setAttribute('data-variant-id', variantId);
    slotEl.setAttribute('data-gallery', gallery);
    slotEl.classList.remove('ctr-qf-buy-box__slot--empty');
    slotEl.classList.add('ctr-qf-buy-box__slot--filled');

    const placeholder = slotEl.querySelector('.ctr-qf-buy-box__slot-placeholder');
    const emptyLabel = slotEl.querySelector('.ctr-qf-buy-box__slot-empty-label');
    const filledWrap = slotEl.querySelector('.ctr-qf-buy-box__slot-filled');
    const imgEl = slotEl.querySelector('.ctr-qf-buy-box__slot-img');
    const imgWrap = slotEl.querySelector('.ctr-qf-buy-box__slot-img-wrap');
    const nameEl = slotEl.querySelector('.ctr-qf-buy-box__slot-name');
    const badgeEl = slotEl.querySelector('.ctr-qf-buy-box__slot-badge');

    if (placeholder) placeholder.hidden = true;
    if (emptyLabel) emptyLabel.hidden = true;
    if (filledWrap) filledWrap.hidden = false;
    if (imgEl) {
      imgEl.src = image;
      imgEl.alt = title;
    }
    if (imgWrap) {
      imgWrap.style.background = bgColor || '';
    }
    if (nameEl) nameEl.textContent = title;
    if (badgeEl) {
      badgeEl.textContent = badge;
      badgeEl.hidden = !badge;
      badgeEl.style.color = badgeColor || '';
    }

    const trigger = slotEl.querySelector('[data-ctr-qf-slot-trigger]');
    if (trigger) {
      trigger.setAttribute('aria-label', title || (emptyLabel ? emptyLabel.textContent.trim() : ''));
    }

    updateSlotRemoveButton(slotEl);

    if (enableGallery) {
      galleryController.onScentSelected(slotEl);
    }
  };

  const clearSlot = (slotEl) => {
    slotEl.setAttribute('data-filled', 'false');
    slotEl.removeAttribute('data-variant-id');
    slotEl.removeAttribute('data-gallery');
    slotEl.classList.add('ctr-qf-buy-box__slot--empty');
    slotEl.classList.remove('ctr-qf-buy-box__slot--filled');

    const placeholder = slotEl.querySelector('.ctr-qf-buy-box__slot-placeholder');
    const emptyLabel = slotEl.querySelector('.ctr-qf-buy-box__slot-empty-label');
    const filledWrap = slotEl.querySelector('.ctr-qf-buy-box__slot-filled');
    const badgeEl = slotEl.querySelector('.ctr-qf-buy-box__slot-badge');
    const trigger = slotEl.querySelector('[data-ctr-qf-slot-trigger]');
    if (placeholder) placeholder.hidden = false;
    if (emptyLabel) emptyLabel.hidden = false;
    if (filledWrap) filledWrap.hidden = true;
    if (badgeEl) {
      badgeEl.textContent = '';
      badgeEl.hidden = true;
      badgeEl.style.color = '';
    }
    if (trigger && emptyLabel) {
      trigger.setAttribute('aria-label', emptyLabel.textContent.trim());
    }
    updateSlotRemoveButton(slotEl);
  };

  const updateAddBottleVisibility = () => {
    const count = getBottleCount();
    const atMax = maxBottles > 0 && count >= maxBottles;
    if (addBottleBtn) {
      addBottleBtn.hidden = atMax;
      addBottleBtn.disabled = atMax;
    }
  };

  const updateUpsell = () => {
    if (!upsellEl) return;
    const count = getFilledCount();
    const defaultText = interpolate(root.getAttribute('data-upsell-text') || '', {
      max_discount: cfg.tier3Pct
    });
    const maxText = root.getAttribute('data-upsell-max-text') || '';
    if (count === 3) {
      upsellEl.hidden = false;
      upsellEl.textContent = defaultText;
    } else if (count >= 4 && maxText) {
      upsellEl.hidden = false;
      upsellEl.textContent = maxText;
    } else {
      upsellEl.hidden = true;
    }
  };

  const updatePlanCards = () => {
    planCards.forEach((card) => {
      const plan = card.getAttribute('data-ctr-qf-plan');
      const isActive = plan === selectedPlan;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const updateSummaryAndCta = () => {
    const filledCount = getFilledCount();
    const tier = getTierPrices(filledCount);
    const pct = getTierPercent(filledCount);
    const perUnit = tier.dis > 0 ? tier.dis : tier.org;
    const total = perUnit * filledCount;
    const displayPrice = cfg.priceDisplayMode === 'per_each' ? perUnit : total;
    const displayPriceSuffix = cfg.priceDisplayMode === 'per_each' ? '/ea' : '';
    let compare = tier.com > 0 ? tier.com : tier.org * filledCount;
    if (compare <= total) {
      compare = cfg.baseOnetime * filledCount;
    }
    const meetsMinimum = filledCount >= minBottles;
    const remaining = Math.max(0, minBottles - filledCount);
    const showEmptySummary = !meetsMinimum;

    if (bottleCountEl) bottleCountEl.textContent = String(filledCount);
    if (bottleCountOnlyEl) bottleCountOnlyEl.textContent = String(filledCount);
    const bottleLabel = filledCount === 1 ? cfg.bottleLabelSingular : cfg.bottleLabelPlural;
    if (bottleSuffixEl) bottleSuffixEl.textContent = bottleLabel;
    if (bottleSuffixOnlyEl) bottleSuffixOnlyEl.textContent = bottleLabel;
    if (summaryHeadingTotalEl && summaryHeadingCountOnlyEl) {
      const perEachMode = cfg.priceDisplayMode === 'per_each';
      summaryHeadingTotalEl.hidden = perEachMode;
      summaryHeadingCountOnlyEl.hidden = !perEachMode;
    }
    root.classList.toggle('is-summary-empty', showEmptySummary);

    if (showEmptySummary) {
      if (summaryTotalEl) summaryTotalEl.textContent = getSelectAtLeastText(remaining);
      if (summaryCompareEl) {
        summaryCompareEl.textContent = '';
        summaryCompareEl.hidden = true;
      }
      if (summaryOffEl) summaryOffEl.hidden = true;
      if (summaryPerEl) summaryPerEl.hidden = true;
    } else {
      if (summaryOffValueEl) summaryOffValueEl.textContent = String(pct);
      if (summaryTotalEl) summaryTotalEl.textContent = `$${formatPrice(displayPrice)}${displayPriceSuffix}`;
      if (summaryCompareEl) {
        if (compare > total) {
          summaryCompareEl.textContent = `$${formatPrice(compare)}`;
          summaryCompareEl.hidden = false;
        } else {
          summaryCompareEl.textContent = '';
          summaryCompareEl.hidden = true;
        }
      }
      if (summaryOffEl) summaryOffEl.hidden = false;
      if (summaryPerEl) summaryPerEl.hidden = false;
    }

    if (summaryTitleEl) {
      summaryTitleEl.textContent = cfg.summaryHeading;
    }

    if (summaryPerEl && !showEmptySummary) {
      summaryPerEl.textContent = interpolate(cfg.perBottleText, {
        billing: getPlanBillingPhrase()
      });
    }

    if (trustDeliveryTextEl) {
      trustDeliveryTextEl.textContent = interpolate(cfg.trustDeliveryText, {
        delivery: getPlanDeliveryPhrase()
      });
    }

    root.setAttribute('data-selected-plan', selectedPlan);

    if (atcBtn && ctaLabelEl && !atcBtn.classList.contains('is-loading')) {
      if (atcBtn.classList.contains('is-added')) {
        clearAtcResetTimer();
        atcBtn.classList.remove('is-added');
      }

      if (meetsMinimum) {
        atcBtn.disabled = false;
        atcBtn.setAttribute('aria-disabled', 'false');
        atcBtn.classList.add('is-ready');
        ctaLabelEl.textContent = `${cfg.ctaPrefix} $${formatPrice(displayPrice)}${displayPriceSuffix}`;
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.classList.remove('is-ready');
        ctaLabelEl.textContent = cfg.ctaDisabled;
      }
    }

    updatePlanCards();
    updateUpsell();
    updateAddBottleVisibility();
    syncAllSlotRemoveButtons();
    syncTotalQty();
  };

  const collectItems = () => {
    const planId = getSelectedSellingPlanId();
    const items = [];

    getFilledSlots().forEach((slot) => {
      const variantId = slot.getAttribute('data-variant-id');
      if (!variantId) return;
      const item = { id: variantId, quantity: 1, properties: {} };
      if (planId) item.selling_plan = planId;
      items.push(item);
    });

    if (items.length > 0) {
      const giftWrapper = document.querySelector('[data-free-gift-variant]');
      if (giftWrapper) {
        const giftVariantId = giftWrapper.getAttribute('data-free-gift-variant');
        if (giftVariantId) {
          items.push({ id: giftVariantId, quantity: 1 });
        }
      }
    }

    return items;
  };

  let atcResetTimer = null;

  const clearAtcResetTimer = () => {
    if (atcResetTimer) {
      clearTimeout(atcResetTimer);
      atcResetTimer = null;
    }
  };

  const setAtcLoading = (loading) => {
    if (!atcBtn || !ctaLabelEl) return;
    clearAtcResetTimer();
    if (loading) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-disabled', 'true');
      atcBtn.setAttribute('aria-busy', 'true');
      atcBtn.classList.remove('is-added');
      atcBtn.classList.add('is-loading');
      ctaLabelEl.textContent = cfg.ctaLoading;
      return;
    }
    atcBtn.classList.remove('is-loading');
    atcBtn.removeAttribute('aria-busy');
  };

  const setAtcAdded = () => {
    if (!atcBtn || !ctaLabelEl) return;
    atcBtn.classList.remove('is-loading');
    atcBtn.classList.add('is-added');
    atcBtn.disabled = true;
    atcBtn.setAttribute('aria-disabled', 'true');
    atcBtn.removeAttribute('aria-busy');
    ctaLabelEl.textContent = cfg.ctaAdded;
  };

  const resetAtcAfterCart = () => {
    clearAtcResetTimer();
    if (!atcBtn) return;
    atcBtn.classList.remove('is-loading', 'is-added');
    atcBtn.removeAttribute('aria-busy');
    updateSummaryAndCta();
  };

  const addToCart = async (items, button) => {
    /* Free gift lines (_ctr_gift) don't count as bottles. */
    const bottles = items.filter((item) => !(item.properties && item.properties._ctr_gift)).length;
    if (bottles < minBottles) {
      alert(getSelectAtLeastText(Math.max(1, minBottles - bottles)));
      return;
    }

    if (button.classList.contains('is-loading')) return;

    let succeeded = false;
    setAtcLoading(true);

    try {
      const config = FoxTheme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);
        if (item.selling_plan) {
          formData.append(`items[${index}][selling_plan]`, item.selling_plan);
        }
        if (item.properties) {
          Object.entries(item.properties).forEach(([key, value]) => {
            formData.append(`items[${index}][properties][${key}]`, value);
          });
        }
      });

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      formData.append('sections', sectionsToBundle.join(','));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const response = await fetch(FoxTheme.routes.cart_add_url, config);
      const responseText = await response.text();
      let parsedState;
      try {
        parsedState = JSON.parse(responseText);
      } catch (e) {
        console.error('CTR QF: Failed to parse cart response', e);
        alert(cfg.alertCartError);
        return;
      }

      if (response.status !== 200 || parsedState.status === 422 || parsedState.status) {
        console.error('CTR QF: Cart add error', parsedState);
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
          source: 'ctr-qf-funnel-buy-box',
          productVariantId: items[0].id,
          errors: parsedState.errors || parsedState.description,
          message: parsedState.message
        });
        alert(parsedState.description || parsedState.message || cfg.alertCartError);
        return;
      }

      const cartResponse = await fetch('/cart.js', FoxTheme.utils.fetchConfig());
      const cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));

      succeeded = true;

      if (cfg.leadAtcDestination === 'checkout') {
        // Skip-cart path: write the recurring-total attribute before navigating.
        if (window.RecurringBridge) { await window.RecurringBridge.flush(); }
        window.location.href = '/checkout';
      } else if (cartDrawer) {
        setAtcAdded();
        cartDrawer.show(button);
        atcResetTimer = setTimeout(resetAtcAfterCart, 2000);
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('CTR QF: Error adding to cart', error);
      alert(cfg.alertCartError);
    } finally {
      if (!succeeded) {
        resetAtcAfterCart();
      }
    }
  };

  /* ── Gallery override (ported from ctr-new-bundle-blockk.js) ── */
  const createGalleryController = () => {
    if (!enableGallery) {
      return { onScentSelected: () => {} };
    }

    const desktopViewerEl = document.querySelector('[id^="GalleryViewer-"]');
    const desktopThumbEl = document.querySelector('[id^="GalleryThumbnails-"]');
    const mobileGalleryEl = document.querySelector('.mediaSwiper');
    const mediaGalleryEl = desktopViewerEl?.closest('media-gallery') ?? null;
    let origDesktop = null;
    let origThumb = null;
    let origMobile = null;
    let originalsStored = false;

    const getRealSlidesHtml = (wrapper) => {
      if (!wrapper) return null;
      return [...wrapper.children]
        .map((child) => (child.classList.contains('swiper-slide-duplicate') ? '' : child.outerHTML))
        .join('');
    };

    const storeOriginals = () => {
      if (originalsStored) return;
      if (desktopViewerEl) {
        const w = desktopViewerEl.querySelector('.swiper-wrapper');
        if (w) origDesktop = getRealSlidesHtml(w);
      }
      if (desktopThumbEl) {
        const tw = desktopThumbEl.querySelector('.swiper-wrapper');
        if (tw) origThumb = getRealSlidesHtml(tw);
      }
      if (mobileGalleryEl) {
        const mw = mobileGalleryEl.querySelector('.swiper-wrapper');
        if (mw) origMobile = getRealSlidesHtml(mw);
      }
      originalsStored = true;
    };

    const buildDesktopSlides = (images) =>
      images
        .map((img, i) => {
          const aspect = img.w && img.h ? (img.w / img.h).toFixed(4) : '1';
          const loading = i === 0 ? 'eager' : 'lazy';
          return (
            `<div class="product__media-item swiper-slide" data-media-id="custom-${i}" data-swiper-slide-index="${i}" data-media-type="image" data-media-index="${i}" data-src="${img.src}">` +
            `<div class="product__media-item-container relative flex overflow-hidden blocks-radius media-type-image" style="--aspect-ratio:${aspect};">` +
            `<img src="${img.src}" alt="${img.alt || ''}" loading="${loading}" width="${img.w || ''}" height="${img.h || ''}" style="width:100%;height:auto;object-fit:cover;">` +
            '</div></div>'
          );
        })
        .join('');

    const buildThumbSlides = (images) =>
      images
        .map(
          (img, i) =>
            `<div class="product__thumbs-item swiper-slide" data-target="custom-${i}" data-swiper-slide-index="${i}" data-media-position="${i + 1}">` +
            '<div class="product__thumbs-container relative blocks-radius-md media-wrapper cursor-pointer">' +
            '<div class="product__thumbs-inner" style="--aspect-ratio:1">' +
            `<img src="${img.src}" alt="${img.alt || ''}" loading="lazy" width="${img.w || ''}" height="${img.h || ''}" style="width:100%;height:100%;object-fit:cover;">` +
            '</div></div></div>'
        )
        .join('');

    const buildMobileSlides = (images) =>
      images
        .map((img, i) => {
          const loading = i === 0 ? 'eager' : 'lazy';
          return (
            '<div class="swiper-slide">' +
            `<img class="mobile-media-img" src="${img.src}" alt="${img.alt || ''}" loading="${loading}" width="${img.w || ''}" height="${img.h || ''}" style="width:100%;height:auto;">` +
            '</div>'
          );
        })
        .join('');

    const updateSwiper = (containerEl, newHtml) => {
      if (!containerEl) return;
      const wrapper = containerEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      const swiper = containerEl.swiper;
      const isLoop = swiper?.params?.loop;
      if (isLoop && typeof swiper.loopDestroy === 'function') swiper.loopDestroy();
      wrapper.innerHTML = newHtml;
      if (swiper) {
        swiper.update();
        if (isLoop && typeof swiper.loopCreate === 'function') {
          swiper.loopCreate();
          swiper.slideToLoop(0, 0);
        } else {
          swiper.slideTo(0, 0);
        }
      }
    };

    const replaceSlidesMarkup = (containerEl, newHtml) => {
      if (!containerEl) return;
      const wrapper = containerEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      wrapper.innerHTML = newHtml;
    };

    const reinitMediaGallerySwipers = () => {
      if (!mediaGalleryEl) return;
      try {
        if (mediaGalleryEl.sliderInstance?.slider) {
          mediaGalleryEl.sliderInstance.slider.destroy(true, true);
        }
        if (mediaGalleryEl.thumbsInstance?.slider) {
          mediaGalleryEl.thumbsInstance.slider.destroy(true, true);
        }
      } catch {
        /* Swiper may already be torn down */
      }
      mediaGalleryEl.sliderInstance = false;
      mediaGalleryEl.thumbsInstance = false;
      if (typeof mediaGalleryEl.init === 'function') mediaGalleryEl.init();
    };

    const applyGallery = (images) => {
      storeOriginals();
      replaceSlidesMarkup(desktopThumbEl, buildThumbSlides(images));
      replaceSlidesMarkup(desktopViewerEl, buildDesktopSlides(images));
      updateSwiper(mobileGalleryEl, buildMobileSlides(images));
      reinitMediaGallerySwipers();
    };

    const restoreGallery = () => {
      if (!originalsStored) return;
      const restore = (el, html) => {
        if (!el || html === null) return;
        const wrapper = el.querySelector('.swiper-wrapper');
        if (!wrapper) return;
        wrapper.innerHTML = html;
        const swiper = el.swiper;
        if (!swiper) return;
        swiper.update();
        if (swiper.params?.loop) swiper.slideToLoop(0, 0);
        else swiper.slideTo(0, 0);
      };
      replaceSlidesMarkup(desktopThumbEl, origThumb);
      replaceSlidesMarkup(desktopViewerEl, origDesktop);
      restore(mobileGalleryEl, origMobile);
      reinitMediaGallerySwipers();
    };

    const parseGallery = (slotEl) => {
      const raw = slotEl.getAttribute('data-gallery');
      if (!raw) return null;
      try {
        const images = JSON.parse(raw);
        return images.length ? images : null;
      } catch {
        return null;
      }
    };

    const resolveFeaturedImages = (preferredSlot) => {
      let images = parseGallery(preferredSlot);
      if (images) return images;
      const slots = getFilledSlots();
      for (const slot of slots) {
        if (slot === preferredSlot) continue;
        images = parseGallery(slot);
        if (images) return images;
      }
      return null;
    };

    return {
      onScentSelected: (slotEl) => {
        const images = resolveFeaturedImages(slotEl);
        if (images) applyGallery(images);
        else restoreGallery();
      }
    };
  };

  const galleryController = createGalleryController();

  /* ── Events ── */
  planCards.forEach((card) => {
    card.addEventListener('click', () => {
      selectedPlan = card.getAttribute('data-ctr-qf-plan') || 'quarterly';
      updateSummaryAndCta();
    });
  });

  slotsEl.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-ctr-qf-slot-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const slotToClear = removeBtn.closest('[data-ctr-qf-slot]');
      if (!slotToClear) return;

      if (isExtraSlot(slotToClear)) {
        removeSlot(slotToClear);
        updateSummaryAndCta();
        return;
      }

      if (slotToClear.getAttribute('data-filled') !== 'true') return;
      const clearIndex = Number.parseInt(slotToClear.getAttribute('data-slot-index'), 10);
      if (!Number.isNaN(clearIndex) && activeSlotIndex === clearIndex && isPickerOpen()) {
        closePicker();
      }
      clearSlot(slotToClear);
      if (enableGallery) {
        galleryController.onScentSelected(slotToClear);
      }
      updateSummaryAndCta();
      return;
    }

    const trigger = e.target.closest('[data-ctr-qf-slot-trigger]');
    if (!trigger || !slotsEl.contains(trigger)) return;
    const slot = trigger.closest('[data-ctr-qf-slot]');
    if (!slot) return;
    const index = Number.parseInt(slot.getAttribute('data-slot-index'), 10);
    if (Number.isNaN(index)) return;
    if (activeSlotIndex === index && isPickerOpen()) {
      closePicker();
      return;
    }
    openPicker(index);
  });

  document.addEventListener('click', (e) => {
    if (!isPickerOpen()) return;
    if (pickerEl.contains(e.target)) return;
    if (e.target.closest('[data-ctr-qf-slot-trigger]')) return;
    closePicker();
  });

  window.addEventListener('resize', () => {
    if (!isPickerOpen() || activeSlotIndex === null) return;
    const slots = getSlots();
    const activeSlot = slots[activeSlotIndex];
    if (activeSlot) positionPicker(activeSlot);
  });

  root.querySelectorAll('[data-ctr-qf-scent-option]').forEach((optionBtn) => {
    optionBtn.addEventListener('click', () => {
      if (optionBtn.disabled || activeSlotIndex === null) return;
      const slots = getSlots();
      const slot = slots[activeSlotIndex];
      if (!slot) return;
      fillSlot(slot, optionBtn);
      closePicker();
      updateSummaryAndCta();
    });
  });

  if (pickerCloseBtn) {
    pickerCloseBtn.addEventListener('click', closePicker);
  }

  if (addBottleBtn) {
    addBottleBtn.addEventListener('click', () => {
      closePicker();
      const count = getBottleCount();
      if (maxBottles > 0 && count >= maxBottles) return;
      if (!slotTemplate?.content) return;
      const clone = slotTemplate.content.firstElementChild.cloneNode(true);
      clone.setAttribute('data-slot-index', String(count));
      clone.setAttribute('data-extra-slot', 'true');
      clone.classList.add('ctr-qf-buy-box__slot--extra');
      slotsEl.appendChild(clone);
      updateSlotRemoveButton(clone);
      reindexSlots();
      updateSummaryAndCta();
    });
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!atcBtn.classList.contains('is-ready')) return;
      /* Same hook as the other buy boxes, so blocks like ctr-free-gifts can
         append lines. The QF funnel only sells subscriptions. */
      const detail = { items: collectItems(), isSubscription: true };
      document.dispatchEvent(new CustomEvent('ctr:before-add-to-cart', { detail }));
      addToCart(detail.items, atcBtn);
    });
  }

  applyDefaultTierOneScent();
  updateSummaryAndCta();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCtrQuarterlyFunnelBuyBox);
} else {
  initCtrQuarterlyFunnelBuyBox();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCtrQuarterlyFunnelBuyBox);
}
